import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import TextField from "@material-ui/core/TextField";
import SuccessIcon from '@material-ui/icons/Done';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import {
    SelectedAppSelector,
    SelectedAppMonteureSelector,
    SelectedAppMonteure
} from '../selectors/SelectedAppointmentSelector';
import {
    SelectAppointmentByID,
    SetPropertyValue,
    SaveData,
    AddPersonToDB,
    SelectPersonByID,
    DeleteDBPersons,
    GetNextPersonId
    // setTitle
} from "../actions/TaskActions";
import DbTasks from "../db/DbTasks";
import { Text } from '../extensions/LangaugeContainer';

const styles = {
    paperinput: {
        textAlign: 'left',
        width: '60%',
        marginLeft: '20%',
        marginRight: '20%',
    },
    paperbutton: {
        width: '60%',
        marginLeft: '20%',
        marginRight: '20%',
        textTransform: 'none',
        marginTop: "20px"
    },
    buttonDel: {
        width: '60%',
        marginLeft: '20%',
        marginRight: '20%',
        textTransform: 'none',
        marginTop: "5px",
    },
    icons: {
        color: '#00B0DE'
    },
}

//provjeriti :host style u staroj aplikaciji
class AddPerson extends Component {
    state = {
        Name: null,
        Vorname: null,
        Tel_1: null
    }
    componentDidMount() {
        this.props.SelectAppointmentByID(this.props.match.params.id);
        this.props.SelectPersonByID(this.props.match.params.person);
        this.setNextPersonID()
    }

    setNextPersonID = async () => {
        let newPersonId = await new DbTasks().getAllPersons();
        let newId = 1;
        if(newPersonId.length !== 0) newId = newPersonId[newPersonId.length - 1].id + 1;        
        this.props.GetNextPersonId(newId);
    }

    saveData = async () => {
        const data = this.props.selectedPerson;
        if (this.props.match.params.person === "-1") {
            // Kreiranje novog montera
                data.id = this.props.nextPersonId;
               // console.log(this.props.nextPersonId);
        } else {
            //Editovanje postojećeg montera
            data.id = this.props.selectedPerson.id;
        }
        //Update/dodavanje novog montera u tabelu persons
        await this.props.AddPersonToDB(data);
        //snimanje u tabelu entereddata u property Persons - potrebno za update podataka na serveru
        await this.props.SaveData(this.props.app, { Persons: this.props.persons })
        this.props.history.goBack();

    }

    handleChange = async e => {
        let Name = "", Vorname = "", Tel_1 = "", Kd_ID = null;
        if (this.props.selectedPerson) {
            Name = this.props.selectedPerson.Name;
            Vorname = this.props.selectedPerson.Vorname;
            Tel_1 = this.props.selectedPerson.Tel_1;
            Kd_ID = this.props.selectedPerson.Kd_ID;
        }
        const data = {
            Name: e.target.name === "Name" ? e.target.value : Name,
            Vorname: e.target.name === "Vorname" ? e.target.value : Vorname,
            Tel_1: e.target.name === "Tel_1" ? e.target.value : Tel_1,
            Kunden_Nr: this.props.app.Kunden_Nr,
            IdFirma: this.props.app.IdFirma,
            Kd_ID: Kd_ID,
            id: 1
        }
        if (this.props.match.params.person === "-1") {
            // Editovanje polja za novog montera
            data.id = this.props.nextPersonId;
            let t = this.props.persons;
            t.push(data);
            //Dodaj novog montera u state.
            await this.props.SetPropertyValue(this.props.app, "Persons", t);
        } else {
            //Editovanje postojećeg montera sa snimanjem u state
            data.id = this.props.selectedPerson.id;
            let persons = this.props.persons.map(val => {
                if (val.id === data.id) {
                    return Object.assign({}, val, data)
                } else return val;
            })
            await this.props.SetPropertyValue(this.props.app, "Persons", persons);
        }
    }

    deleteMonteure = async e => {
        let id = this.props.selectedPerson.id;
        let allPersons = this.props.app.Persons 
        if(!allPersons) allPersons =  this.props.persons;
            let persons = allPersons.map(val => {
                if (val.id === id) {
                    val.Deleted = true;
                    return val;
                } else return val;
            })
            await this.props.SaveData(this.props.app, { Persons: persons })
        //Brisanje montera iz tabele persons
        await this.props.DeleteDBPersons(this.props.selectedPerson.id);
        this.props.history.goBack();
    }

    render() {
        let Name = null, Tel_1 = null, Vorname = null;
        if (this.props.selectedPerson) {
            Name = this.props.selectedPerson.Name;
            Vorname = this.props.selectedPerson.Vorname;
            Tel_1 = this.props.selectedPerson.Tel_1;
        }
       // console.log("AddPerson props: ", this.props.app);
        return (
            <div>
                <div>
                    <TextField type='text' style={styles.paperinput}
                        name="Name"
                        label={<Text tid="name" />}
                        onChange={this.handleChange}
                        value={Name || ""}
                    />
                    <TextField type='text' style={styles.paperinput}
                        name="Vorname"
                        label={<Text tid="lastName" />}
                        onChange={this.handleChange}
                        value={Vorname || ""}
                    />
                    <TextField type='text' style={styles.paperinput}
                        name="Tel_1"
                        label={<Text tid="telephoneNr" />}
                        onChange={this.handleChange}
                        value={Tel_1 || ""}
                    />
                    <Button style={styles.paperbutton} id='_finished' onClick={this.saveData} variant="outlined">
                        {<Text tid="finish" />}
                        <SuccessIcon style={styles.icons} />
                    </Button>
                    {this.props.match.params.person !== "-1" && <Button style={styles.buttonDel} onClick={this.deleteMonteure} id='_buttonDel' variant="outlined">
                        {<Text tid="delete" />}
                        <DeleteIcon style={styles.icons} />
                    </Button>}

                </div>
            </div>
        );
    }
};

const mapStateToProps = state => ({
    app: SelectedAppSelector(state),
    selectedPerson: SelectedAppMonteure(state),
    persons: SelectedAppMonteureSelector(state),
    nextPersonId : state.tasks.nextPersonId
});

const connected = connect(mapStateToProps, {
    // setTitle,
    SelectAppointmentByID,
    SetPropertyValue,
    SaveData,
    AddPersonToDB,
    SelectPersonByID,
    DeleteDBPersons,
    GetNextPersonId
})(AddPerson);

export default withRouter(connected);